"use client";
import _defineProperty from '@babel/runtime/helpers/defineProperty';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import * as React from 'react';
import { colors } from '../constants/colors.js';
import { HeaderContext } from './HeaderContext.js';
import { headerRender } from './headerRender.js';

var _excluded = ["backgroundColor", "foregroundColor", "hoverColor", "highlightColor", "centerComponentColor", "leftComponent", "centerComponent", "rightComponent"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), true).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/**
 * @deprecated -- Please do not use this component. It is deprecated and will be removed in the future is no longer receiving updates.
 */
var Header = function Header(_ref) {
  var _ref$backgroundColor = _ref.backgroundColor,
    backgroundColor = _ref$backgroundColor === undefined ? colors.snowWhite : _ref$backgroundColor,
    _ref$foregroundColor = _ref.foregroundColor,
    foregroundColor = _ref$foregroundColor === undefined ? colors.inkGrey : _ref$foregroundColor,
    _ref$hoverColor = _ref.hoverColor,
    hoverColor = _ref$hoverColor === undefined ? colors.oceanGreen : _ref$hoverColor,
    _ref$highlightColor = _ref.highlightColor,
    highlightColor = _ref$highlightColor === undefined ? colors.oceanGreen : _ref$highlightColor,
    _ref$centerComponentC = _ref.centerComponentColor,
    centerComponentColor = _ref$centerComponentC === undefined ? colors.poweringGreen : _ref$centerComponentC,
    leftComponent = _ref.leftComponent,
    centerComponent = _ref.centerComponent,
    rightComponent = _ref.rightComponent,
    props = _objectWithoutProperties(_ref, _excluded);
  var colorProps = {
    backgroundColor: backgroundColor,
    foregroundColor: foregroundColor,
    hoverColor: hoverColor,
    highlightColor: highlightColor,
    centerComponentColor: centerComponentColor
  };
  return /*#__PURE__*/React.createElement(HeaderContext.Provider, {
    value: {
      headerProps: _objectSpread({
        leftComponent: leftComponent,
        centerComponent: centerComponent,
        rightComponent: rightComponent
      }, props),
      colorProps: colorProps
    }
  }, headerRender(_objectSpread({
    leftComponent: leftComponent,
    centerComponent: centerComponent,
    rightComponent: rightComponent
  }, props), colorProps));
};

export { Header };
